import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import getSource from '../../../utils/get-source';
import { appStorage, parseQueryString } from '../../../utils/utils'
import apiRequest from '../../../utils/api.request';
import lodash from 'lodash';
import config from '../../../config.json';
import useLoader from '../../../hooks/use-loader';
import backArrow from '../../../images/back-arrow-white.svg';
import cov19notif from '../../../images/vaccination-images/cov-19-notif.png';
import cov19pass from '../../../images/vaccination-images/cov-19-pass.png';
import cov19vaccbook from '../../../images/vaccination-images/cov-19-vacc-book.png';
import cov19vacccert from '../../../images/vaccination-images/cov-19-vacc-cert.png';
import docconsult from '../../../images/vaccination-images/doc-consult.png';
import managehealthrec from '../../../images/vaccination-images/manage-health-rec.png';
import useTranslation from '../../../hooks/use-translation';

import Input from './Components/InputForm'

import DifferentJhhIdFlow from './DifferentJhhIdFlow';
import CreateNewJhhIdFlow from './CreateNewJhhIdFlow';
import ProfileDetails from './ProfileDetails';

import { vaccinationApiRequestBody } from './Utils/vaccinationApiRequestBody';

import './VaccinationDetailsWrapper.css';

const source_array_for_surveyv5 = ["emp_xp", "jioHealthHub"];
const get_previous_response = config.covid_vacc_base_url + "v1/previous-response/";
const get_profile_details_url = config.covid_vacc_base_url + "v1/get-partner-info/";
const capture_interest_url = config.covid_vacc_base_url + "v1/capture-interest/";
let user_name;

const VaccinationDetailsWrapper = () => {
  const [showSurvey, toggleShowSurvey] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { showLoading, hideLoading, loadingCount } = useLoader();
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const [yesSelected, setYesSelected] = useState(false);
  const [noSelected, setNoSelected] = useState(false);
  const [alreadyVaccinatedSelected, _setAlreadyVaccinatedSelected] = useState(false);
  const [userJourney, setUserJourney] = useState('corporate-jhh-id')
  const [cancelClicked, setCancelClicked] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [loadUserJourneyError, setLoadUserJourneyError] = useState(false);
  const [yesNoSelectedLoader, setYesNoSelectedLoader] = useState(false);
  const [yesNoSelectedError, setYesNoSelectedError] = useState(false);
  const [previousResponse, _setPreviousResponse] = useState(false);
  const [jhhIdValidated, _setJhhIdValidated] = useState(false);
  const [showCorporateFlow, _setShowCorporateFlow] = useState(false);
  const [showGhostIdMessage, _setShowGhostIdMessage] = useState(false);
  const user_details = useRef();
  const thank_you_ref = useRef();
  const {t} = useTranslation();

  const getCovidSurveyIdEss = async (user_details) => {
    const url = get_previous_response;
    const dataobj = vaccinationApiRequestBody({}, user_details)
    const response = await apiRequest(url, dataobj, true);
    if (response.status === "success") {
      if (String(lodash.get(response,"previous_response")).toLowerCase() == "yes") {
        _setPreviousResponse(true);
      };
      if (String(lodash.get(response,"jhh_id_validated")).toLowerCase() == "yes") {
        _setJhhIdValidated(true);
      };
      return response.workflow_id;

    } else {
      throw (lodash.get(response, "response.data.message", "Something went wrong, please try again"));
    }
  }

  const getCovidSurveyIdJhh = async (source_user_id, source_id) => {
    const url = config.vaccineInterestUrl;
    const dataobj = {
      jhh_id: source_user_id,
      source: source_id,
    }
    try {
      const response = await apiRequest(url, dataobj, true);
      if (response.status === "success") {
        return response.workflow_id;
      } else {
        throw ("error");
      }
    } catch (err) {
      throw (err);
    }
  }

  useEffect(() => {
    showLoading();
    const params = parseQueryString();
    getSource()
      .then(({ source_user_id, source_id, business_id }) => {
        if ((source_array_for_surveyv5.indexOf(source_id) < 0) || !source_user_id) {
          hideLoading();
          setErrorMessage('Session Timed out. Please login again');
          toggleShowSurvey(false);
        }
        else {
          switch (source_id) {
            case "emp_xp": {
              const { t, source_relation, source_user_relation_id, auth_token } = params;
              const name = atob(t);
              if (name && auth_token && business_id && source_relation && source_user_relation_id) {
                user_details.current = {
                  name,
                  auth_token,
                  business_id,
                  source_relation,
                  source_user_relation_id,
                  source_id,
                  source_user_id
                }
                user_name = name;
                getCovidSurveyIdEss(user_details.current)
                .then((response) => {
                toggleShowSurvey(true);
                })
                .catch(error => {
                  hideLoading(true);
                  setErrorMessage(error || 'Session Timed out. Please login again');
                  toggleShowSurvey(false);
                })
                break;
              } else {
                hideLoading(true);
                setErrorMessage('Session Timed out. Please login again.');
                toggleShowSurvey(false);
                break;
              }
            }
            case "jioHealthHub": {
              const { t: name, source_relation, source_user_relation_id, auth_token } = params;
              if (name && auth_token && business_id && source_relation && source_user_relation_id) {
                user_name = name;
                try {
                  getCovidSurveyIdJhh(source_user_id, source_id)
                    .then((response) => {
                      toggleShowSurvey(true);
                    })
                } catch (err) {
                  hideLoading(true);
                  setErrorMessage('Session Timed out. Please login again.');
                  toggleShowSurvey(false);
                }
                break;
              } else {
                hideLoading(true);
                setErrorMessage('Session Timed out. Please login again.');
                toggleShowSurvey(false);
                break;
              }
            }
            default: {
              hideLoading(true);
              setErrorMessage('Session Timed out. Please login again.');
              toggleShowSurvey(false);
              break;
            }
          }
        }
      })
  }, [])

  useEffect(() => {
    if (showSurvey) {
      hideLoading();
    }
  }, [showSurvey])

  useEffect(() => {
    if (yesSelected)
      thank_you_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [yesSelected])

  const _captureInterest = async (interestValue) => {
    setYesNoSelectedError("");
    let dataObj = {
      "interest_value": interestValue
    }
    dataObj = vaccinationApiRequestBody(dataObj, user_details.current);
    const response = await apiRequest(capture_interest_url, dataObj, true);

    if (lodash.get(response, "status") !== "success") {
      setYesNoSelectedError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
      setYesNoSelectedLoader(false);
      throw (lodash.get(response, "response.data.message", "Something went wrong, please try again"));
    }

    if(interestValue == "no"){
      setYesNoSelectedLoader(false);
      setNoSelected(true);
    }
    if(interestValue == "already-vaccinated") {
      setYesNoSelectedLoader(false);
      _setAlreadyVaccinatedSelected(true);
    }
  }

  const handleExpressClick = async (input) => {
    setYesNoSelectedLoader(input);
    switch (input) {
      case 'Yes': {
        try {
          await _captureInterest("yes")
          if (jhhIdValidated) {
            setYesNoSelectedLoader(false);
            setYesSelected(true);
            break;
          } 
          const requestBody = vaccinationApiRequestBody({}, user_details.current)
          apiRequest(get_profile_details_url, requestBody, true)
            .then(response => {
              if (response && response.apiResponse !== "failed") {
                setUserInfo({
                  name: lodash.get(response, "name", ""),
                  gender: lodash.get(response, "gender", ""),
                  date_of_birth: lodash.get(response, "date_of_birth", ""),
                  phone: lodash.get(response, "phone", ""),
                  jhhID: lodash.get(response, "jhh_id", ""),
                  primaryPhone: lodash.get(response, "primary_jhh_info.phone", "")
                });
                if(user_details.current.source_relation !== "Self" && !lodash.get(response,"primary_jhh_info.jhh_id","")) {
                  setLoadUserJourneyError("Primary jhh id does not exist.");
                  _setShowGhostIdMessage(true);
                } else {
                  _setShowGhostIdMessage(false);
                  setLoadUserJourneyError(false);
                  if(lodash.get(response,"jhh_id","")){
                    _setShowCorporateFlow(true);
                  } else {
                    _setShowCorporateFlow(false)
                  }
                }
              } else {
                setLoadUserJourneyError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
              }
              setYesNoSelectedLoader(false);
              setYesSelected(true);
            })
        } catch (err) {
        }
        break;
      }
      case 'No':
        try {
          await _captureInterest('no');
        } catch (error) {          
        }
        break;

      case "already-vaccinated":
        try {
          await _captureInterest("already-vaccinated");
        } catch (error) {
        }
        break;
      default:
        break;
    }
  }

  const handleUserJourneyChange = (userJourney) => {
    setUserJourney(userJourney)
  }

  const UserJourney = () => {
    switch (userJourney) {
      case 'corporate-jhh-id':
        return <ProfileDetails showCorporateFlow={showCorporateFlow} userInfo={userInfo} profileDetails={user_details.current} handleUserJourneyChange={handleUserJourneyChange} t={t} />;
      case 'different-jhh-id':
        return <DifferentJhhIdFlow showCorporateFlow={showCorporateFlow} handleUserJourneyChange={handleUserJourneyChange} profileDetails={user_details.current} userName={user_name} t={t} />;
      case 'create-new-jhh-id':
        return <CreateNewJhhIdFlow showCorporateFlow={showCorporateFlow} handleUserJourneyChange={handleUserJourneyChange} userInfoFromApi={userInfo} profileDetails={user_details.current} t={t} />;
    }
  }

  return (
    <div>
      {
        showSurvey ?
          <div className="paddingLarge express-interest-width-wrapper">
            <div className="express-interest-wrapper">
              <div className="person-name">
                <div className="express-interest-back-button">
                  <img className="back-arrow express-interest-back-arrow" onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} src={backArrow} alt="arrow back"></img>
                </div>
                  <div className="express-interest-header-text">{t("EOI_EXPRESSION_OF_INTEREST")}</div>
                </div>
            </div>
            <div className="express-interest-question express-interest-first-question">
              <div className="express-interest-left-col">
                <p className="express-interest-first-question-description">
                  {previousResponse 
                    ? `${user_name}, ${t("EOI_INTEREST_EXPRESSION_TEXT_PREVIOUS_RESPONSE_YES")}`
                    : (`${t("EOI_INTEREST_EXPRESSION_TEXT_PREVIOUS_RESPONSE_NO")} ${user_name}`)
                  }
                </p>
                <br/>
                <p className="express-interest-first-question-description small-font" dangerouslySetInnerHTML={{ __html : t("EOI_TNC_TEXT")}}></p>
              </div>
              <div ref={thank_you_ref} className="express-interest-right-col">
                <div className="express-interest-first-question-buttons">
                  <button 
                    className={`express-interest-yes-button ${yesNoSelectedLoader === "Yes" ? "loading" : ""} ${yesSelected ? "selected" : ""}`} 
                    onClick={() => handleExpressClick("Yes", user_details.current)}
                    disabled={yesNoSelectedLoader || (yesSelected || noSelected || alreadyVaccinatedSelected)}
                  >{t("EOI_YES")}</button>
                  <button
                    className={`express-interest-no-button ${yesNoSelectedLoader === "No" ? "loading" : ""} ${noSelected ? "selected" : ""}`}
                    onClick={() => handleExpressClick("No")}
                    disabled={yesNoSelectedLoader || (yesSelected || noSelected || alreadyVaccinatedSelected)}
                  >{t("EOI_NO")}</button>
                  <div>
                    <button
                      className={`express-interest-vaccinated-button ${yesNoSelectedLoader === "already-vaccinated" ? "loading" : ""} ${alreadyVaccinatedSelected ? "selected" : ""}`}
                      onClick={() => handleExpressClick("already-vaccinated")}
                      disabled={yesNoSelectedLoader || (yesSelected || noSelected || alreadyVaccinatedSelected)}
                    >
                      {t("EOI_ALREADY_VACCINATED")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {
              yesNoSelectedError &&
              <p className="form-element-error load-user-journey-error">{yesNoSelectedError}</p>
            }
            {yesSelected &&
              <>
                <p className="express-interest-thank-you-text">
                  {t("EOI_THANK_YOU_MESSAGE_YES_SELECTED")}
                  {jhhIdValidated && <>{` ${t("EOI_THANK_YOU_MESSAGE_YES_SELECTED_NOTIFY_MESSAGE")}`}</>}
                </p>
                {jhhIdValidated 
                  ? <>
                    <p className="express-interest-thank-you-text" >{t("EOI_THANK_YOU_MESSAGE_YES_SELECTED_JHH_VALIDATED_YES")}</p>
                  </>
                  :<>
                    <p className="express-interest-thank-you-text" >{t("EOI_THANK_YOU_MESSAGE_YES_SELECTED_JHH_VALIDATED_NO")}</p>
                  </>  
                }
                <div className="express-interest-services-container">
                  <div>
                    <img className="express-interest-services-img" src={cov19notif} />
                    <p className="express-interest-services-text">{t("TIMELY_NOTIFICATIONS_COVID19_VACCINE")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19vaccbook} />
                    <p className="express-interest-services-text">{t("COVID19_VACCINE_BOOKING")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19vacccert} />
                    <p className="express-interest-services-text">{t("COVID19_VACCINE_CERTIFICATE")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19pass} />
                    <p className="express-interest-services-text">{t("COVID19_PASS_SERVICES")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={docconsult} />
                    <p className="express-interest-services-text">{t("DOCTOR_CONSULT_SERVICES")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={managehealthrec} />
                    <p className="express-interest-services-text">{t("MANAGING_HEALTH_RECORDS")}</p>
                  </div>
                </div>
                <br></br>
                {jhhIdValidated ?
                  <Input
                    type="button"
                    addClassInput="express-interest-modal-button-yes express-interest-close-button"
                    value={t("EOI_DONE")}
                    onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} 
                  />
                  :
                  <>
                    {showGhostIdMessage 
                      ? <p className="express-interest-thank-you-text font-red" >{t("EOI_GHOST_ID_MESSAGE")}</p>
                      : <p className="express-interest-thank-you-text" >{t("LETS_CREATE_JHH_ID")}</p>
                    }
                  </>
                }
              </>
            }
            {(noSelected || alreadyVaccinatedSelected) &&
              <div>
                { noSelected &&
                  <>
                  <p className="express-interest-thank-you-text">{t("EOI_THANK_YOU_MESSAGE_NO_SELECTED")}</p>
                  <p className="express-interest-thank-you-text">{t("EOI_THANK_YOU_MESSAGE_LOGIN_SIGNUP")}</p>
                  </>
                }
                { alreadyVaccinatedSelected &&
                  <>
                  <p className="express-interest-thank-you-text">
                    {t("EOI_THANK_YOU_MESSAGE_ALREADY_VACCINATED_1")}
                  </p>
                  <p className="express-interest-thank-you-text">{t("EOI_THANK_YOU_MESSAGE_ALREADY_VACCINATED_2")}</p>
                  </>
                }
                <div className="express-interest-services-container">
                  <div>
                    <img className="express-interest-services-img" src={cov19notif} />
                    <p className="express-interest-services-text">{t("TIMELY_NOTIFICATIONS_COVID19_VACCINE")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19vaccbook} />
                    <p className="express-interest-services-text">{t("COVID19_VACCINE_BOOKING")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19vacccert} />
                    <p className="express-interest-services-text">{t("COVID19_VACCINE_CERTIFICATE")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={cov19pass} />
                    <p className="express-interest-services-text">{t("COVID19_PASS_SERVICES")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={docconsult} />
                    <p className="express-interest-services-text">{t("DOCTOR_CONSULT_SERVICES")}</p>
                  </div>
                  <div>
                    <img className="express-interest-services-img" src={managehealthrec} />
                    <p className="express-interest-services-text">{t("MANAGING_HEALTH_RECORDS")}</p>
                  </div>
                </div>
                <br></br>
                {alreadyVaccinatedSelected ? 
                  <Input
                        type="button"
                        addClassInput="express-interest-modal-button-yes express-interest-close-button"
                        value={t("UPLOAD_COWIN_CERTIFICATE")}
                        onClick={() => history.push(`/vaccination-certificate/cowin?${urlParams.toString()}`)} />
                : <Input
                        type="button"
                        addClassInput="express-interest-modal-button-yes express-interest-close-button"
                        value={t("EOI_DONE")}
                        onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} />
                }
              </div>
            }
            {yesSelected && !loadUserJourneyError && !jhhIdValidated &&
              <UserJourney />
            }
            {yesSelected && loadUserJourneyError &&
              <div>
                {!showGhostIdMessage && <p className="form-element-error load-user-journey-error">{loadUserJourneyError}</p>}
                <Input
                      type="button"
                      addClassInput="express-interest-modal-button-yes express-interest-close-button"
                      value={t("EOI_DONE")}
                      onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} />
              </div>
            }
            {cancelClicked &&
              <div className="express-interest-modal-container">
                <div className="express-interest-modal-body">
                  <p className="express-interest-modal-text">{t("EOI_CANCEL_TEXT")}</p>
                  <div className="express-interest-modal-buttons">
                    <Input
                      type="button"
                      addClassInput="express-interest-modal-button-no"
                      value={t("EOI_NO")}
                      onClick={() => setCancelClicked(false)} />
                    <Input
                      type="button"
                      addClassInput="express-interest-modal-button-yes"
                      value={t("EOI_YES")}
                      onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} />
                  </div>
                </div>
              </div>
            }
          </div>
          :
          <>{
            !loadingCount && <div className="paddingLarge text-align-center">{typeof errorMessage == "string" ? errorMessage : t("EOI_FALLBACK_ERROR_MESSAGE")}</div>
          }</>
      }
    </div>
  );
};

export default VaccinationDetailsWrapper;